/* eslint-disable */
import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
const routes = require('./routes.js');

Vue.use(VueRouter)
const router = new VueRouter({
  routes,
  mode: 'history',
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) {
      return {
        selector: to.hash
      }
    }
    if (savedPosition) {
      return savedPosition
    } else {
      return {x: 0, y: 0}
    }
  }
})

//Route guard
router.beforeEach((to, from, next) => {
  
  //Increment history stack indicator to recognize user visited views and to check if user comes from another page to redirect after ,login to start view
  if(store){
    store.commit('settings/INCREMENT_APP_HISTORY');
  }

  const storedPrivacyVersion = localStorage.getItem('privacyVersion');
  const currentPrivacyVersion = process.env.VUE_APP_PRIVACY_VERSION;

  // if (to.path !== '/datenschutz' && (!storedPrivacyVersion || storedPrivacyVersion !== currentPrivacyVersion)) {
  //   next({ path: '/datenschutz', query: { redirect: to.fullPath } });
  // } else {
    if(null!=to && to.meta && to.meta.requiresAuth){
      if(store && store.state && store.state.settings && store.state.settings.app_logged_in) {
        if(to.meta.requireAdminAuth){
          setTimeout(() => {
            //QuickFix: Use Timeout to give isAdmin time to render
            if(store.getters['settings/isAdmin']){
              next();
            }else{
              next('/login');
            }
          },300);
        }else{
          next(); // allow to enter route as user
        }
      } else{
        next('/login'); // go to '/login';
      }
    }else{
      next();
    }
  // }
})

export default router
